import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const ContactsList = lazy(() => import('../../pages/contacts/ContactsListTable'));
const ContactDetails = lazy(() => import('../../pages/contacts/details/index'));
const ConversationSummaries = lazy(() => import('../../pages/contacts/conversation-summaries/index'));
function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`} component={ContactsList} />
            <Route exact path={`${path}/conversation-summaries`} component={ConversationSummaries} />
            <Route exact path={`${path}/list/:listId`} component={ContactsList} />
            <Route path={`${path}/details/:id`} component={ContactDetails} />
            {/* <Route path={`${path}`} component={Users} /> */}
        </Switch>
    );
}

export default PagesRoute;
